/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
// core components
import styles from "assets/jss/material-dashboard-react/components/footerStyle.js";

import "./footer.css";
import frameworks from "assets/img/frameworks.svg";
const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={(classes.inlineBlock, classes.block)}>
              Version: 2.0.1
            </ListItem>
          </List>
        </div>
        <p className={classes.right}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a
                className="footDev"
                href="https://github.com/PqES/frontGrammar"
                rel="noopener noreferrer"
                onClick={(_) => {
                  window.open("https://github.com/PqES/backGrammar");
                }}
                target="_blank"
              >
                Developers &nbsp; <img alt="" src={frameworks} width="65" />
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                className="footAndrew"
                href="https://github.com/4andrewtanakashi"
                rel="noopener noreferrer"
                target="_blank"
              >
                Andrew T.
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                className="footMarcos"
                href="https://github.com/Marcos-Pimentel"
                rel="noopener noreferrer"
                target="_blank"
              >
                Marcos P.
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                className="footPedro"
                href="https://github.com/Pedronorton"
                rel="noopener noreferrer"
                target="_blank"
              >
                Pedro P.
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                className="fooTerra"
                href="http://professores.dcc.ufla.br/~terra/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Ricardo Terra
              </a>
            </ListItem>
          </List>
        </p>
      </div>
    </footer>
  );
}
